import { Address } from '@/models/address';

export interface QuoteRequestInfo {
   salutation: string;
   firstName: string;
   lastName: string;
   emailAddress: string;
   address: Address;
   message: string;
   sendViaMail: boolean;
}

export function createEmptyQuoteRequestInfo(): QuoteRequestInfo {
   return {
      address: {}
   } as QuoteRequestInfo;
}
